"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FaceVeryUnhappyOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FaceVeryUnhappyOutlineSVG = function FaceVeryUnhappyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm0,2A12,12,0,1,0,28,16,12,12,0,0,0,16,4Zm0,14a8.48,8.48,0,0,1,5.71,2.29,1,1,0,0,1-1.42,1.42,6.24,6.24,0,0,0-8.58,0,1,1,0,0,1-1.42-1.42A8.48,8.48,0,0,1,16,18Zm-4-7a2,2,0,1,1-2,2A2,2,0,0,1,12,11Zm8,0a2,2,0,1,1-2,2A2,2,0,0,1,20,11Z"
  }));
};
exports.FaceVeryUnhappyOutlineSVG = FaceVeryUnhappyOutlineSVG;
FaceVeryUnhappyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FaceVeryUnhappyOutlineSVG);
exports.default = _default;